module.exports = __webpack_public_path__ + "img/company.47345f93.png";